export default __webpack_public_path__ + "static/proxima-nova-600-f88fb234e02535b30eef990db268a0ad.woff";